/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputAlternativeChannel
 */
export interface OutputAlternativeChannel {
    /**
     * 
     * @type {string}
     * @memberof OutputAlternativeChannel
     */
    band: string;
    /**
     * 
     * @type {string}
     * @memberof OutputAlternativeChannel
     */
    channel: string;
    /**
     * 
     * @type {number}
     * @memberof OutputAlternativeChannel
     */
    freq: number;
}

/**
 * Check if a given object implements the OutputAlternativeChannel interface.
 */
export function instanceOfOutputAlternativeChannel(value: object): boolean {
    if (!('band' in value)) return false;
    if (!('channel' in value)) return false;
    if (!('freq' in value)) return false;
    return true;
}

export function OutputAlternativeChannelFromJSON(json: any): OutputAlternativeChannel {
    return OutputAlternativeChannelFromJSONTyped(json, false);
}

export function OutputAlternativeChannelFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputAlternativeChannel {
    if (json == null) {
        return json;
    }
    return {
        
        'band': json['band'],
        'channel': json['channel'],
        'freq': json['freq'],
    };
}

export function OutputAlternativeChannelToJSON(value?: OutputAlternativeChannel | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'band': value['band'],
        'channel': value['channel'],
        'freq': value['freq'],
    };
}

